var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnpinFromCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3533 3.64616C3.35334 3.64615 3.35337 3.64613 3.35341 3.64612L4.20727 4.49998H4.20712L3.3533 3.64616ZM2.5 5.62114V15C2.5 15.8284 3.17157 16.5 4 16.5H13.3788L12.3788 15.5H4C3.72386 15.5 3.5 15.2761 3.5 15V6.62114L2.5 5.62114ZM8.53189 11.653L7.04608 13.1388V13.6333L7.54107 13.6338L9.02688 12.148L8.53189 11.653ZM15.2071 15.5L16.1946 16.4875C16.1947 16.4875 16.1947 16.4875 16.1947 16.4875L15.2073 15.5H15.2071ZM10.4411 10.7338L10.441 10.7339L9.94603 10.2389L9.9461 10.2388L10.4411 10.7338ZM16.4091 15.2876L17.1197 15.9982C17.3562 15.733 17.5 15.3833 17.5 15V8.23793L16.5357 9.20227L16.5 9.1666V15C16.5 15.107 16.4664 15.2062 16.4091 15.2876ZM12.9587 11.8372L8.85408 7.73258L8.99072 7.59594L10.419 7.58406L13.6351 4.36798L13.1854 3.91833L13.6804 3.42334L17.2674 7.01026L16.7724 7.50525L16.3227 7.05561L13.1066 10.2717L13.0953 11.7005L12.9587 11.8372ZM5.62149 4.49998H6.89645C7.0607 4.49998 7.21448 4.58066 7.30783 4.7158L7.81676 5.45253C8.09683 5.85796 8.55816 6.09998 9.05092 6.09998H9.96928L10.9693 5.09998H9.05092C8.88667 5.09998 8.73289 5.01931 8.63954 4.88417L8.13061 4.14744C7.85054 3.742 7.38921 3.49998 6.89645 3.49998H4.62149L5.62149 4.49998ZM11.6663 6.09998H11.6664L12.6664 5.09998H12.6663L11.6663 6.09998Z",
    fill: "#181818"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.70709,
    width: 1,
    height: 20,
    transform: "rotate(-45 2 3.70709)",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinFromCategory);
export default __webpack_public_path__ + "static/media/unpin_from_category.44943d915714e821aca6a8a342e6bb3a.svg";
export { ForwardRef as ReactComponent };